import { InstanceScreen } from 'component/navigation/instance';

export default function AdminEmailPreviewScreen() {
    return <InstanceScreen screenKey='emailPreview' />;
}
